import { render, staticRenderFns } from "./NewPwdLessLogin.vue?vue&type=template&id=2cc70140&scoped=true"
import script from "./NewPwdLessLogin.vue?vue&type=script&lang=js"
export * from "./NewPwdLessLogin.vue?vue&type=script&lang=js"
import style0 from "./NewPwdLessLogin.vue?vue&type=style&index=0&id=2cc70140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc70140",
  null
  
)

export default component.exports